/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetCreateUpdateResponse {
    getFixupPrototypeFunction() { return BudgetCreateUpdateResponse.fixupPrototype; }

    static newInstance(model: Partial<BudgetCreateUpdateResponse>): BudgetCreateUpdateResponse {
        let obj = Object.assign(new BudgetCreateUpdateResponse(), model);
        BudgetCreateUpdateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetCreateUpdateResponse>): BudgetCreateUpdateResponse {
        if (!model) return null;
        return BudgetCreateUpdateResponse.newInstance(<BudgetCreateUpdateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetCreateUpdateResponse) {
        if (!obj) return;

        models.BudgetCreateUpdateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetCreateUpdateResponse): boolean {
        Object.setPrototypeOf(obj, BudgetCreateUpdateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * tenant id
     */
    tenant_id: string;

    /**
     * created/updated budget name
     */
    budget_name: string;

    /**
     * true if budget created in corestack
     */
    is_corestack_created: boolean;

    /**
     * true if recurring budget
     */
    is_recurring: boolean;

    /**
     * Specify the budget ID.This is a unique ID and can be retrieved using the create budget_UI
     */
    budget_id: string;

    /**
     * budget engine
     */
    budget_engine: string;

    /**
     * Specify the budget frequency. Example: 'budget frequency':'Daily' Allowed values - Daily,Monthly,Quarterly,Annually
     */
    budget_frequency: string;

    /**
     * budget type
     */
    budget_type: string;

    /**
     * budget uri
     */
    budget_uri: string;

}
